<div *routerOuter class="row">
  <div class="col col-120 col-lg-100 col-xl-80" *ngIf="item">

    <form-group-context label="ID">
      <span>{{ item.id }}</span>
    </form-group-context>

    <form-group-context label="Created At">
      <span>{{ item.createdAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Updated At">
      <span>{{ item.updatedAt | moment }}</span>
    </form-group-context>

    <form-group-context label="Name">
      <span>{{ item.name }}</span>
    </form-group-context>

    <form-group-context label="Store" *ngIf="item.store">
      <entity-link type="store" [item]="item.store"></entity-link>
    </form-group-context>

    <form-group-context label="Active">
      <badge-exist existText="Active" existColor="success" [item]="item.active"></badge-exist>
    </form-group-context>

    <form-group-context label="Available for downloading">
      <badge-exist existText="Available" existColor="success" [item]="item.availableForDownloading"></badge-exist>
    </form-group-context>

    <form-group-context label="Product">
      <entity-link type="product" [item]="item.product"></entity-link>
    </form-group-context>


    <form-group-context label="Projects">
      <div [class.mb-1]="!last" *ngFor="let project of item.projects; let last = last">
        <entity-link type="project" [item]="project" [showInfo]="false"></entity-link>
      </div>
    </form-group-context>

  </div>
</div>
